// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"article-preview-module--previewTitle--16pYm"};